var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9164 7.60045C22.1574 8.49432 23 9.87955 23 11.5C23 13.1205 22.1574 14.5067 20.9164 15.3995C21.1673 16.9071 20.7763 18.492 19.6336 19.6336C18.4889 20.7784 16.905 21.159 15.4037 20.9143C14.514 22.1595 13.1163 23 11.5 23C9.87955 23 8.49118 22.1563 7.59941 20.9133C6.09605 21.159 4.51114 20.7795 3.36532 19.6336C2.22055 18.4889 1.84 16.904 2.093 15.3995C0.853091 14.5078 0 13.1215 0 11.5C0 9.8785 0.853091 8.49118 2.093 7.60045C1.84 6.09605 2.22055 4.51114 3.36636 3.36636C4.50905 2.22264 6.095 1.83268 7.60777 2.08359C8.49432 0.840545 9.88268 0 11.5 0C13.1152 0 14.5109 0.8395 15.4016 2.08359C16.9092 1.83268 18.492 2.22473 19.6336 3.36636C20.7763 4.508 21.1684 6.09291 20.9164 7.60045Z",
    fill: "#83B564"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 9,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsUncheck);
export default __webpack_public_path__ + "static/media/details-uncheck.bfcfbaac4618c9339a01f1c2d4bb3b6e.svg";
export { ForwardRef as ReactComponent };